// src/galleryData.js
export const galleryData = [
  {
    name: "Watching Waves",
    wallColor: 0x1a3a5c, // Navy Blue
    images: [
      { path: process.env.PUBLIC_URL + '/gallery/WatchingWaves/crash.jpg', name: 'Crash' },
      { path: process.env.PUBLIC_URL + '/gallery/WatchingWaves/erosion.jpg', name: 'Erosion' },
      { path: process.env.PUBLIC_URL + '/gallery/WatchingWaves/fall.jpg', name: 'Fall' },
      { path: process.env.PUBLIC_URL + '/gallery/WatchingWaves/floating.jpg', name: 'Floating' },
      { path: process.env.PUBLIC_URL + '/gallery/WatchingWaves/ice.jpg', name: 'Ice' },
      { path: process.env.PUBLIC_URL + '/gallery/WatchingWaves/octo.jpg', name: 'Octopussy' },
      { path: process.env.PUBLIC_URL + '/gallery/WatchingWaves/reflection.jpg', name: 'Reflection' },
      { path: process.env.PUBLIC_URL + '/gallery/WatchingWaves/greatWave.jpg', name: 'Great Wave' },
      { path: process.env.PUBLIC_URL + '/gallery/WatchingWaves/niagaraFalls.jpg', name: 'Niagara Falls' },
      { path: process.env.PUBLIC_URL + '/gallery/WatchingWaves/mountains.jpg', name: 'Mountain Range' },
    ]
  },
  {
    name: "Coloring Book",
    wallColor: 0x8b2942, // Maroon
    images: [
      { path: process.env.PUBLIC_URL + '/gallery/ColoringBook/hydrangeas.jpg', name: 'Hydrangeas' },
      { path: process.env.PUBLIC_URL + '/gallery/ColoringBook/jellyfishes.jpg', name: 'Jellyfishes' },
      { path: process.env.PUBLIC_URL + '/gallery/ColoringBook/lalQila.jpg', name: 'Lal Qila' },
      { path: process.env.PUBLIC_URL + '/gallery/ColoringBook/lotus.jpg', name: 'Lotus' },
      { path: process.env.PUBLIC_URL + '/gallery/ColoringBook/owl.jpg', name: 'Owl' },
      { path: process.env.PUBLIC_URL + '/gallery/ColoringBook/rose.jpg', name: 'Rose' },
      { path: process.env.PUBLIC_URL + '/gallery/ColoringBook/sara.jpg', name: 'Girl' },
      { path: process.env.PUBLIC_URL + '/gallery/ColoringBook/violet.jpg', name: 'Violet' },
      { path: process.env.PUBLIC_URL + '/gallery/ColoringBook/cherryBlossoms.jpg', name: 'Cherry Blossoms' },
      { path: process.env.PUBLIC_URL + '/gallery/ColoringBook/love.jpg', name: 'Best Friends' },
    ]
  },
  {
    name: "That Which Remains",
    wallColor: 0xd4a017, // Golden Yellow
    images: [
      { path: process.env.PUBLIC_URL + '/gallery/Misc/aspen.jpg', name: 'Aspen' },
      { path: process.env.PUBLIC_URL + '/gallery/Misc/bird.jpg', name: 'Bird' },
      { path: process.env.PUBLIC_URL + '/gallery/Misc/crazy.jpg', name: 'Crazy' },
      { path: process.env.PUBLIC_URL + '/gallery/Misc/eternalDance.jpg', name: 'Eternal Dance' },
      { path: process.env.PUBLIC_URL + '/gallery/Misc/heart.jpg', name: 'Heart' },
      { path: process.env.PUBLIC_URL + '/gallery/Misc/mangoes.jpg', name: 'Mangoes' },
      { path: process.env.PUBLIC_URL + '/gallery/Misc/mural.jpg', name: 'Mural' },
      { path: process.env.PUBLIC_URL + '/gallery/Misc/chick.jpg', name: 'Pretty Woman' },
      { path: process.env.PUBLIC_URL + '/gallery/Misc/old.jpg', name: 'Old' },
      { path: process.env.PUBLIC_URL + '/gallery/Misc/sumo.jpg', name: 'Sumo Wrestler' }
    ]
  }
];